var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "flag"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7619_29146",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.183594,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7619_29146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "flag_2",
    d: "M6.01725 11.6666V16.6666C6.01725 16.9028 5.93739 17.1007 5.77767 17.2604C5.61795 17.4201 5.42003 17.5 5.18392 17.5C4.94781 17.5 4.74989 17.4201 4.59017 17.2604C4.43045 17.1007 4.35059 16.9028 4.35059 16.6666V4.16665C4.35059 3.93054 4.43045 3.73262 4.59017 3.5729C4.74989 3.41317 4.94781 3.33331 5.18392 3.33331H11.1631C11.3575 3.33331 11.5311 3.39581 11.6839 3.52081C11.8367 3.64581 11.9339 3.80554 11.9756 3.99998L12.1839 4.99998H16.0173C16.2534 4.99998 16.4513 5.07984 16.611 5.23956C16.7707 5.39929 16.8506 5.5972 16.8506 5.83331V12.5C16.8506 12.7361 16.7707 12.934 16.611 13.0937C16.4513 13.2535 16.2534 13.3333 16.0173 13.3333H11.7048C11.5103 13.3333 11.3367 13.2708 11.1839 13.1458C11.0311 13.0208 10.9339 12.8611 10.8923 12.6666L10.6839 11.6666H6.01725Z",
    fill: "#EE4F4F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.645d4f2ab86eb56620392868686e8fc0.svg";
export { ForwardRef as ReactComponent };